import {actions as A} from '../constants/actions';

export const showLittlePopup = message => dispatch => (
  dispatch({
    type: A.SHOW_LITTLE_POPUP,
    payload: message
  })
);

export const hideLittlePopup = () => dispatch => (
  dispatch({
    type: A.HIDE_LITTLE_POPUP
  })
);
